import React from "react";
import { Link } from "gatsby";
import { ReactComponent as Arrow } from "@svgs/arrow.svg"
import { usePagination } from "@src/hooks/usePagination";

const Pagination = ({ currentPage, totalPages, onPageChange, isLink = true }) => {
  const pageRange = Array.from({ length: totalPages }, (_, index) => index + 1);
  const prevPage = pageRange[currentPage - 2];
  const nextPage = pageRange[currentPage]

  const Component = isLink ? Link : 'div';

  const paginationRange = usePagination({
    currentPage: +currentPage ,
    totalCount: pageRange.length,
    siblingCount: 1
  });

  return (
    <div className="flex justify-center items-center gap-x-5 relative w-fit mx-auto h-fit">
      <Component 
        className={`w-10 h-10 cursor-pointer bg-white drop-shadow-md rounded-full flex justify-center items-center !p-0 ${!prevPage ? 'cursor-not-allowed opacity-50' : ''}`} 
        arrow={'none'} 
        theme={'none'} 
        to={`${prevPage > 1 && !isLink ? '?page=' + prevPage : ''}`} 
        onClick={() =>{prevPage ? onPageChange(prevPage) : ''}}
        disabled={!prevPage}
        role={'button'}
        aria-label={`Previous Page ${!prevPage ? ', disabled' : ''}`}
      >
        <Arrow className='max-w-5 rotate-180'/>
      </Component>

      <div className="flex justify-center items-center gap-x-7">
        {paginationRange.map((page, index) => {
          if(page === '...') {
            return ( <span key={index}>{page}</span>)
          }
          return (
            <Component
              key={page}
              className={`${+currentPage === page ? "text-black" : "text-darker-gray"} cursor-pointer`}
              onClick={() => onPageChange(page)}
              to={`${page === 1 && isLink ? '' : '?page=' + page}`}
              disabled={!nextPage ? true : false}
              role={'button'}
              aria-label={`Page ${page}`}
            >
              {page}
            </Component>
          )
        })}
      </div>

      <Component 
        className={`w-10 h-10 cursor-pointer bg-white drop-shadow-md rounded-full flex justify-center !p-0 items-center ${!nextPage ? 'opacity-50 cursor-not-allowed' : ''}`} 
        arrow={'none'} 
        theme={'none'} 
        to={`${nextPage > 1 && isLink ? '?page=' + nextPage : '?page=' + currentPage}`} 
        onClick={() => {nextPage ? onPageChange(nextPage) : ''}}
        disabled={!nextPage}
        role={'button'}
        aria-label={`Next Page ${!nextPage ? ', disabled' : ''}`}
      >
        <Arrow className='max-w-5'/>
      </Component>
    </div>
  );
};

export default Pagination;